import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { FormCancelButton, FormSaveButton } from 'common/components';

const CertificateFooter = (props) => {
  const {
    loading,
    onCancel,
    onSubmit,
    currentStep,
    handleBackToCreateAsset,
    handleMoveToLinkAsset,
    isAllowedUpload,
    hasDigitalAssets,
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
      }}
    >
      {currentStep === 0 && (
        <FormCancelButton
          icon={<ArrowRightOutlined />}
          text='Move to link step'
          disabled={isAllowedUpload || !hasDigitalAssets}
          onClick={handleMoveToLinkAsset}
        />
      )}
      {currentStep === 1 && (
        <FormCancelButton
          disabled={currentStep === 0}
          text={' Back to asset creation'}
          icon={<ArrowLeftOutlined />}
          onClick={() => handleBackToCreateAsset && handleBackToCreateAsset()}
        />
      )}
      <FormCancelButton
        onClick={() => {
          onCancel && onCancel(null);
        }}
      />
      <FormSaveButton
        disabled={currentStep === 0}
        loading={loading}
        onClick={onSubmit}
      />
    </div>
  );
};

export default CertificateFooter;
